import { FileDownload } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { GridRowSelectionModel } from '@mui/x-data-grid';

import Button from '@/components/button';
import { useExportCreatorsList } from '@/hooks/queries/creators';
import useAlert from '@/hooks/useAlert';
import { Creator } from '@/models/creator';

interface ExportCreatorsProps {
  groupId?: GridRowSelectionModel;
  creatorList?: Creator.List;
}

const ExportCreators = ({ groupId, creatorList }: ExportCreatorsProps) => {
  const alert = useAlert();
  const isDisabled =
    (groupId && groupId.length !== 1) || creatorList?.totalItems === 0;

  const { mutate: exportCreatorsList, isPending: isExportPending } =
    useExportCreatorsList({
      onSuccess: (response) => {
        const blob = new Blob([response?.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', 'creators-export.csv');
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        link.remove();
        alert.success('The CSV file has been successfully downloaded.');
      },
      onError: () => {
        alert.error('Something went wrong while exporting the CSV.');
      }
    });

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      padding="8px 12px 0 12px"
      gap={1}
    >
      <Button
        size="small"
        text="export list"
        variant="text"
        loading={isExportPending}
        disabled={isDisabled}
        onClick={() => exportCreatorsList(Number(groupId))}
        startIcon={<FileDownload />}
        sx={{
          color: 'text.primary',
          '& .MuiSvgIcon-root': {
            color: 'text.primary'
          },
          '&.Mui-disabled': {
            color: 'action.disabled',
            '& .MuiSvgIcon-root': {
              color: 'action.disabled'
            }
          }
        }}
      />
    </Stack>
  );
};

export default ExportCreators;
